export interface BackOfficeLoggedInViewModel {
  email: string;
}

export const mocked_BackOfficeLoggedInViewModel_Get: BackOfficeLoggedInViewModel =
  { email: 'test@test.com' };
